import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import parse from "html-react-parser";

import HeaderSection from "pages/Home/Header";
import FooterSection from "pages/Home/Footer";
import { getOptionValue } from "common/enums";
import Loader from "Components/Common/Loader";

import { useGetMenuItemsQuery } from "apis/HomePage";

const GiftInfo = () => {
  const { state } = useLocation();

  const { data: { data: menuItems } = {}, isLoading: isMenuDataLoading } =
    useGetMenuItemsQuery();

  const getMenuData = (items) => {
    return items.flatMap((item) =>
      item.child ? [...getMenuData(item.child), item] : [item]
    );
  };

  const { content = "" } = useMemo(
    () =>
      menuItems?.length
        ? getMenuData(menuItems).find(({ id, contentType }) =>
            state?.id
              ? state.id === id
              : contentType === getOptionValue("homeContentType", "Text")
          )
        : {},
    [menuItems, state?.id]
  );

  if (isMenuDataLoading) return <Loader />;

  return (
    <div className="d-flex flex-column justify-content-between min-vh-100">
      <div className="header-nav-wrapper nav-background">
        <div className="container-fluid">
          <HeaderSection menuItems={menuItems} isGiftInfo />
        </div>
      </div>

      <div
        className="ql-editor container-fluid vision-section"
        style={{ paddingTop: "130px" }}
      >
        {parse(content)}
      </div>

      <FooterSection menuItems={menuItems} isGiftInfo />
    </div>
  );
};

export default GiftInfo;
